<template>
<div class="chapter">
<div class="inner_page">
<p class="top1"><a id="page_ii"></a><span class="bold">CarCraft 2</span></p>
<h1 class="title">Porsche 911 <span class="title1">CLASSIC GERMAN SPORTS CAR</span></h1>
<p class="author"><span class="bold">Lance Cole</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?cf44bca2